<template>
  <div class="index">
    <div class="box">
      <table-tap
        :header="header"
        :data="data"
      ></table-tap>
    </div>
  </div>
</template>

<script>
  import tableTap from '../../components/table-scroll'

  const initSize = 40
  const initRemian = 10
  const initStart = 100
  const listCount = 1000
  const getIndexList = (count) => {
    let list = []
    for (let i = 0; i < count; i++) {
      list.push({
        age: i,
        cc: 17
      })
    }
    return list
  }

  export default {
    name: "index",
    data() {
      return {
        header2: [
          {
            title: 'John Brown',
            key: 'age',
            width: 60,
            fixed: 'left',
            align: 'right'
          },
          {
            title: 'Johnad',
            key: 'age',
            width: 60,
            fixed: 'left',
            align: 'right'
          },
          {
            title: 'John---',
            key: 'age',
            width: 60,
            fixed: 'left',
            align: 'right'
          },
          {
            title: 'Johncc',
            key: 'age',
            children: [
              {
                title: 'cc',
                width: 100,
                key: 'cc'
              },
              {
                title: 'cc',
                width: 100,
                key: 'cc'
              }
            ]
          },
          {
            title: 'John ---',
            width: 100,
            key: 'age'
          },
          {
            title: 'John --',
            width: 100,
            key: 'age'
          },
          {
            title: 'John -',
            width: 100,
            key: 'age'
          },
          {
            title: 'John-',
            width: 100,
            key: 'age'
          },
          {
            title: 'John',
            width: 100,
            key: 'age'
          }
        ],
        header1: [
          {
            title: 'John Brown',
            key: 'age',
            width: 60,
            fixed: 'left',
            align: 'right'
          },
          {
            title: 'Johnad',
            key: 'age',
            width: 60,
            fixed: 'left',
            align: 'right'
          },
          {
            title: 'John---',
            key: 'age',
            width: 60,
            align: 'right'
          },
          {
            title: 'John-',
            key: 'age',
            width: 100
          },
          {
            title: 'John-',
            key: 'age',
            width: 100
          },
          {
            title: 'John-',
            key: 'age',
            width: 100
          },
          {
            title: 'John-',
            key: 'age',
            width: 100
          },
          {
            title: 'John-',
            key: 'age',
            width: 100
          }
        ],
        data2: getIndexList(listCount),
        data1: getIndexList(109),
        size: initSize,
        remian: initRemian,
        start: initStart,
        items: getIndexList(listCount),
        scrollelement: null,
        tap: 1,

        header: [],
        data: []
      }
    },
    created() {
      this.cc(this.tap)
    },
    computed: {},
    methods: {
      cc(to) {
        this.header = this['header2']
        this.data = this['data2']
      }
    },
    components: {
      tableTap
    },
    mounted() {
      this.scrollelement = this.$refs.scrollelement
    },
    beforeDestroy() {
    }
  }
</script>

<style scoped lang="scss">
  .index {
    .box {
      background: #ccc;
      padding: 10px;
      height: 500px;
      overflow: auto;
    }
  }
</style>
